import _ from 'lodash';
import linkifyIt from 'linkify-it';

const linkify = linkifyIt();

export default function formatUrl(url = '') {
  return _.get(linkify.match(url), '[0].url', `http://${url}`.replace(/http:\/\/$/, ''));
}



// WEBPACK FOOTER //
// ./app/services/format-url.js